var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpcionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.363,
    height: 13.363,
    viewBox: "0 0 13.363 13.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13375",
    "data-name": "Grupo 13375",
    transform: "translate(-952 -3707.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_450",
    "data-name": "Elipse 450",
    transform: "translate(952 3707.742)",
    fill: "#CCEAF0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.682,
    cy: 6.682,
    r: 6.682,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.682,
    cy: 6.682,
    r: 6.182,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_30552",
    "data-name": "Rect\\xE1ngulo 30552",
    width: 2,
    height: 7,
    rx: 1,
    transform: "translate(957.682 3709.682)",
    fill: "#0099B7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1260",
    "data-name": "Elipse 1260",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(957.682 3717.682)",
    fill: "#0099B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpcionalIcon);
export default __webpack_public_path__ + "static/media/OpcionalIcon.fa6908b381a3da29d2e6a55cc8fedaa8.svg";
export { ForwardRef as ReactComponent };